import { type JSX, Show } from 'solid-js';
import { type ControlGlyph, ControlIcon } from './ControlIcon';

// One job or epic control (#6753, prototype `.jbtn`, `:760-764`): an icon button, or with
// `labelled` (one job, the large layout) the icon and its word. While the page is locked or
// the control saves it is `aria-disabled` (still focusable, so the keyboard keeps its place)
// and a press does nothing; while it saves it is also `aria-busy`.

export function ControlButton(props: {
  readonly glyph: ControlGlyph;
  /** "Pause the Coder job": the accessible name and the title. */
  readonly name: string;
  /** "Pause": shown beside the icon when `labelled`. */
  readonly word: string;
  readonly labelled?: boolean | undefined;
  readonly held: boolean;
  readonly busy?: boolean | undefined;
  readonly onPress: () => void;
  /** Marks a Stop button, so a closed confirm hands focus back to it. */
  readonly stopFor?: string | undefined;
}): JSX.Element {
  return (
    <button
      type="button"
      class="mission-ctl__btn"
      classList={{ 'mission-ctl__btn--labelled': props.labelled === true }}
      aria-label={props.name}
      title={props.name}
      aria-disabled={props.held ? 'true' : undefined}
      aria-busy={props.busy === true ? 'true' : undefined}
      data-stop-for={props.stopFor}
      onClick={() => {
        if (!props.held) props.onPress();
      }}
    >
      <ControlIcon glyph={props.glyph} />
      <Show when={props.labelled === true}>
        <span>{props.word}</span>
      </Show>
    </button>
  );
}
